import { useState, useEffect, Fragment } from 'react';
import './App.css';
import ScrollToTop from './Pages/ScrollToTop';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import NotFoundPage from './Pages/notFound';
import './assets/css/style.css';
import './assets/css/professor.css';
import './assets/css/responsive.css';
import './assets/css/bootstrap.min.css';
import { routes } from './routes';
import { loadStripe } from '@stripe/stripe-js';
import { apiPath } from './configs';
import 'react-toastify/dist/ReactToastify.css';
import { ToasterContainer } from './shared/ToastContainer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { classInfo } from './Store/api/classApi';
import { SelectOption } from './Pages/Book/models/SelectOption';
import { FaviconUpdater } from './shared/Favico.jsx';

const App = () => {
  const [stripePromise, setStripePromise] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const { classes } = useSelector((state) => state.entities.classes);
  const [isModalShow, setIsModalShow] = useState(false);

  const pathname = window.location.pathname;

  // Split the pathname by '/' and get the first fragment
  const firstFragment = pathname.split('/').filter(Boolean)[0];

  const dispatch = useDispatch();
  useEffect(() => {
    fetch(`${apiPath}api/config`)
      .then(async (r) => {
        const { publishableKey } = await r.json();
        setStripePromise(loadStripe(publishableKey));
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
    if (user && user?.role === 'PROFESSOR' && firstFragment !== 'signup') {
      dispatch(classInfo({ onSuccess: () => {}, onError: () => {} }));
    }
  }, [user, dispatch, firstFragment]);
  useEffect(() => {
    if (user && user.role === 'PROFESSOR' && classes.length && classes.some((e) => !e.isBookAssociated)) {
      setIsModalShow(true);
    } else {
      setIsModalShow(false);
    }
  }, [classes, user]);

  return (
    <div>
      <ToasterContainer />
      <Router>
        <ScrollToTop />
        <FaviconUpdater />
        <Routes>
          {routes.map((route, index) => {
            const { component: Component } = route;
            return (
              <Fragment key={index}>
                <Route key={route.path} path={route.path} element={<Component from={route.path} stripePromise={stripePromise} />} exact={route.exact} />
              </Fragment>
            );
          })}
          <Route path='*' element={<Navigate to='/404' />} />
          <Route path='/404' element={<NotFoundPage />} />
        </Routes>
        {isModalShow && firstFragment !== 'signup' && <SelectOption selectOption={isModalShow} setSelectOption={setIsModalShow} mode='app' />}
      </Router>
    </div>
  );
}

export default App;
